import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree, } from '@angular/router';
import { Observable } from 'rxjs';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';

@Injectable({
    providedIn: 'root',
})

/*
export class AuthGuard implements CanActivate {
    constructor(
        protected readonly router: Router) {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return true;
    }
}
*/



export class AuthGuard extends KeycloakAuthGuard {
    constructor(
        protected readonly router: Router,
        protected readonly keycloak: KeycloakService
    ) {
        super(
            router,
            keycloak
        );
    }

    public async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {

        // Force the user to log in if currently unauthenticated.
        if (!this.authenticated) {
            await this.keycloak.login({
                redirectUri: window.location.origin + state.url,
            });
        }

        // Get the roles required from the route.
        const requiredRoles = route.data.roles;

        // Allow the user to to proceed if no additional roles are required to access the route.
        if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
            return true;
        }

        if (route.url.length === 2 && route.url[1].toString() === 'management' &&
            (this.roles.includes(Role.CatalogManagement) || this.roles.includes(Role.Templates) || this.roles.includes(Role.Coverage)
            || this.roles.includes(Role.FtthLoad) || this.roles.includes(Role.TaskManagement) || this.roles.includes(Role.MasterData)
            || this.roles.includes(Role.PortOut))) {
            return true;
        }

        // Allow the user to proceed if all the required roles are present.
        if (requiredRoles.every((role) => this.roles.includes(role))) {
            return true;
        } else {
            this.router.navigate(['/', '403']);
            return false;
        };
    }
}
